import React from 'react';
import { getPhotoUrl, getSmallThumbnailUrl } from '../../shared/util/MiscUtil';
import Lightbox from 'react-image-lightbox';
import noPhoto from '../../assets/images/no-photo.png';
import sortBy from 'lodash.sortby';

export default function PhotoGrid({ listingId, photos, listing, ...rest }) {

    const photosSorted = !!photos && photos.length > 0 && sortBy(photos, ["order", "id"]);

    const [primaryPhoto, setPrimaryPhoto] = React.useState((!!photosSorted && photosSorted.length > 0) ? photosSorted[0] : undefined);
    const [isLightboxOpen, setIsLightboxOpen] = React.useState(false);
    const [photoIndex, setPhotoIndex] = React.useState(0);

    const images = !!photosSorted && photosSorted.length > 0 ? photosSorted.map(photo => getPhotoUrl(listingId, photo.fileName)) : [];

    const handlePhotoClick = (event, photo, index) => {
        // scroll smoothly to the center of horizontally scrollable photo container
        const scrollToPosition = event.target.parentElement.offsetLeft -
            event.target.parentElement.parentElement.clientWidth / 2 +
            event.target.parentElement.clientWidth / 2;

        if (event.target.parentElement.offsetLeft >= scrollToPosition) {
            event.target.parentElement.parentElement.scroll({ left: scrollToPosition, behavior: "smooth" });
        } else {
            event.target.parentElement.parentElement.scroll({ left: scrollToPosition / 1.3, behavior: "smooth" });
        }
        // set primary photo to currently selected one from grid
        setPrimaryPhoto(photo);
        setPhotoIndex(index);
    }

    return (
        <div className="photo-grid" {...rest}>
            <div className="mb-2 rounded-md bg-gray-lighter overflow-hidden border-1 border-gray-lighter">
                {!listing.discountActive && !!primaryPhoto &&
                    <img className="object-cover object-center h-100 w-full mx-auto cursor-pointer" src={getPhotoUrl(listingId, primaryPhoto.fileName)} alt={primaryPhoto.caption} onClick={() => setIsLightboxOpen(!isLightboxOpen)}  width={626} height={430} />
                }
                {!!listing.discountActive && !!primaryPhoto &&
                    <div className="relative">
                    <img className="object-cover object-center h-100 w-full mx-auto cursor-pointer" src={getPhotoUrl(listingId, primaryPhoto.fileName)} alt={primaryPhoto.caption} onClick={() => setIsLightboxOpen(!isLightboxOpen)}  width={626} height={430} />
                    <div className="bg-purple text-white w-14 text-center font-semibold top-0 rounded-md absolute">
                        -{listing.discount}<span className="text-sm">%</span>
                    </div>
                    </div>
                }
                {!listing.discountActive && !primaryPhoto &&
                    <img className="object-cover object-center h-100 w-full mx-auto" src={noPhoto} alt="Nema fotografije" width={626} height={430} />
                }
                {!!listing.discountActive && !primaryPhoto &&
                    <div className="relative">
                        <img className="object-cover object-center h-100 w-full mx-auto" src={noPhoto} alt="Nema fotografije" width={626} height={430} />
                        <div className="bg-purple text-white w-14 text-center font-semibold top-0 rounded-md absolute">
                            -{listing.discount}<span className="text-sm">%</span>
                        </div>
                    </div>
                }
            </div>
            {!!photos && photos.length > 1 && (
                <div className="flex flex-nowrap items-center justify-start w-full overflow-x-hidden overflow-y-hidden">
                    {photosSorted.map((photo, index) => (
                        <div className={"py-3 mr-4 flex-shrink-0" + (index === photos.length - 1 ? " pr-64" : "")} key={index}>
                            <img
                                className={"object-cover h-24 w-32 rounded-md border-2 cursor-pointer"
                                    + (photo.id === primaryPhoto.id ? " border-purple" : " border-gray-lighter")}
                                src={getSmallThumbnailUrl(listingId, photo.fileName)}
                                alt={photo.caption}
                                onClick={(event) => handlePhotoClick(event, photo, index)}
                            />
                        </div>
                    ))}
                </div>
            )}
            {isLightboxOpen && (
                <Lightbox
                    mainSrc={images[photoIndex]}
                    nextSrc={images[(photoIndex + 1) % images.length]}
                    prevSrc={images[(photoIndex + images.length - 1) % images.length]}
                    onCloseRequest={() => setIsLightboxOpen(false)}
                    onMovePrevRequest={() =>
                        setPhotoIndex((photoIndex + images.length - 1) % images.length)
                    }
                    onMoveNextRequest={() =>
                        setPhotoIndex((photoIndex + 1) % images.length)
                    }
                    imageLoadErrorMessage="Sliku nije moguće učitati"
                    zoomInLabel="Uvećaj"
                    zoomOutLabel="Umanji"
                    closeLabel="Zatvori"
                />
            )}
        </div>
    );
}
